import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -8","key":"svg-0"}],["path",{"d":"M20 11v2","key":"svg-1"}],["path",{"d":"M7 12h-.01","key":"svg-2"}]]

const IconDeviceMobileRotated = createReactComponent('outline', 'device-mobile-rotated', 'DeviceMobileRotated', __iconNode);

export default IconDeviceMobileRotated;